module.exports = __webpack_public_path__ + "static/media/IconTemplates_-96.25a0663c.svg";